import { Component, OnDestroy, OnInit, TemplateRef, Optional } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';

import { AlertConfig, AlertController } from './alert-controller';

@Component({
  selector: 'ui-alert',
  templateUrl: './alert.component.html'
})
export class AlertComponent implements OnInit, OnDestroy {
  show: boolean = false;

  title: string | TemplateRef<any> = '';
  content: string | TemplateRef<any> = '';
  btnText: string = '';

  get titleIsString() {
    return typeof this.title === 'string';
  }

  get contentIsString() {
    return typeof this.content === 'string';
  }

  private subs: Subscription[] = [];

  constructor(private alertController: AlertController,
              @Optional() private router: Router) {
  }

  ngOnInit() {
    if (this.router) {
      this.subs.push(this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.checked();
        }
      }));
    }
    // è®¢éalertäºä»¶
    this.subs.push(this.alertController.alertConfig.subscribe((params: AlertConfig) => {
      // è®¾ç½®ç¶æï¼ä»¥å¼¹åºå¯¹è¯æ¡
      this.show = true;

      this.title = params.title;
      this.content = params.content;
      this.btnText = params.btnText;
    }));
  }

  ngOnDestroy() {
    this.subs.forEach(item => item.unsubscribe());
  }

  checked() {
    // å½ç¹å»ç¡®è®¤ææ­æ¶å³é­å¼¹çª
    this.show = false;
  }

  hide() {
    // å½å¼¹çªå¨ç»å®ææ¶ï¼åå¸äºä»¶
    this.alertController.publishAction();
  }
}